import { GET, setParams } from '../../_http';
import type { operations } from '@/types/schemas/api.main';
type controller = operations['BrokerRetrieveUtmMetricsController_get'];

export type BrokerRetrieveUtmMetricsResponse = controller['responses']['200']['content']['application/json'];

export const retrieveUtmMetrics = GET(
  '/brokers/utm-metrics/retrieve-utm-metrics',
  setParams<undefined>,
)<BrokerRetrieveUtmMetricsResponse>;
